import React from "react";
import Lottie from "lottie-react";
import noDataAnimation from "./no-data.json";

const NoData = ({ message = "No data available." }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 300,
    }}
  >
    <div style={{ width: 200, height: 200 }}>
      <Lottie animationData={noDataAnimation} loop={false} />
    </div>
    <p style={{ marginTop: 16, fontSize: 18, color: "#888" }}>{message}</p>
  </div>
);

export default NoData;
